import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import BatchTable from "../batchTable";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { CircularProgress } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabs: {
    backgroundColor: "#fff", // White background for tabs
    color: "#000", // Default text color for tabs
  },
  tab: {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
  },
  selectedTab: {
    color: "#5f90db", // Blue text color for the selected tab
    fontWeight: 500, // Bold font for selected tab
    fontSize: "14px",
  },
  indicator: {
    backgroundColor: "#5f90db", // Blue indicator for selected tab
  },
}));

export default function StatusTab({ data }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusTable, setStatusTable] = useState({});

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllBatchesForSL
      `,
        {
          schrockenSLID: data.schrockenSLID,
          committedQuantity: data.committedQuantity,
          // committedQuantity: 30,
        }
      )
      .then((res) => {
        // throw new Error("mock error");
        if (res.data.status) {
          const statusData = res.data.data.statusBasedBatchDetailsList;

          const statusMap = statusData.reduce((acc, item) => {
            const status = item.batchData.statusDescription;
            acc[status] = item.batchDetailsList || [];
            return acc;
          }, {});
          setStatusTable(statusMap);
          setApiData(res.data.data.statusBasedBatchDetailsList);
          setLoading(false);
          setError(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(err);
        console.log("Error", err.message);
      });
  }, []);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", // Horizontally center the CircularProgress
          alignItems: "center", // Vertically center the CircularProgress
          height: "50px", // Optional: Set a height to vertically center the loader
          border: "2px solid #FF0000",
          backgroundColor: "#FFF0F0",
          width: "100%",
        }}
      >
        <Typography style={{ textAlign: "center" }}>
          Something went wrong. Please try again.
        </Typography>
      </div>
    );
  }
  if (loading) {
    return (
      <div style={{ textAlign: "center" }}>
        <CircularProgress color="primary" thickness={7} />
      </div>
    );
  }
  if (apiData?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", // Horizontally center the CircularProgress
          alignItems: "center", // Vertically center the CircularProgress
          height: "50px", // Optional: Set a height to vertically center the loader
          border: "2px solid #000",
          // backgroundColor: "#FFF0F0",
          width: "100%",
        }}
      >
        <Typography style={{ textAlign: "center" }}>
          No Records Found
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{
            root: classes.tabs,
            indicator: classes.indicator, // Style the indicator
          }}
        >
          <Tab
            label={`Received (${(statusTable["Received"] || []).length})`}
            {...a11yProps(0)}
            classes={{ root: classes.tab, selected: classes.selectedTab }} // Style the selected tab
          />
          <Tab
            label={`Dispatched (${(statusTable["Dispatched"] || []).length})`}
            {...a11yProps(1)}
            classes={{ root: classes.tab, selected: classes.selectedTab }}
          />
          <Tab
            label={`Under approval (${
              (statusTable["Under approval"] || []).length
            })`}
            {...a11yProps(2)}
            classes={{ root: classes.tab, selected: classes.selectedTab }}
          />
          <Tab
            label={`Production complete (${
              (statusTable["Production complete"] || []).length
            })`}
            {...a11yProps(3)}
            classes={{ root: classes.tab, selected: classes.selectedTab }}
          />
          <Tab
            label={`Under production (${
              (statusTable["Under production"] || []).length
            })`}
            {...a11yProps(4)}
            classes={{ root: classes.tab, selected: classes.selectedTab }}
          />
          <Tab
            label={`Scheduled (${(statusTable["Scheduled"] || []).length})`}
            {...a11yProps(5)}
            classes={{ root: classes.tab, selected: classes.selectedTab }}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {/* Received */}
        <BatchTable
          data={statusTable["Received"] || []}
          plantCode={data?.plantCode}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        {/* Dispatched */}
        <BatchTable
          data={statusTable["Dispatched"] || []}
          plantCode={data?.plantCode}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        {/* Under approval */}
        <BatchTable
          data={statusTable["Under approval"] || []}
          plantCode={data?.plantCode}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        {/* Production complete */}
        <BatchTable
          data={statusTable["Production complete"] || []}
          plantCode={data?.plantCode}
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        {/* Under production */}
        <BatchTable
          data={statusTable["Under production"] || []}
          plantCode={data?.plantCode}
        />
      </TabPanel>
      <TabPanel value={value} index={5}>
        {/* Scheduled */}
        <BatchTable
          data={statusTable["Scheduled"] || []}
          plantCode={data?.plantCode}
        />
      </TabPanel>
    </div>
  );
}
